import React from 'react'
import { Link } from 'react-router-dom'
import Privacy from '../Views/Privacy'
import Terms from '../Views/Terms'

const Footer = () => {
    return (
        <>
            {/* <!-- ============================ -->
            <!-- FOOTER -->
            <!-- ============================ --> */}
            <footer className="bg_dark dark_bg footer">
                <div className="container">
                    <div className="left">
                        <a href="#" className="logo icon">
                            <img src="images/footer_logo.svg" alt="" />
                        </a>
                        <span>Peck in social networks</span>
                        <ul className="social_icons">
                            <li><a href="https://www.instagram.com/peckdating" alt=""><img src="images/instagram.svg" alt="" /></a></li>
                            <li><a href="https://www.facebook.com/peckdating"><img src="images/fb_icon.svg" alt="" /></a></li>
                            <li><a href="https://www.linkedin.com/company/peckdating/"><img src="images/linked_In.svg" alt="" /></a></li>
                            <li><a href="https://www.youtube.com/@peckdating"><img src="images/youtube_icon.svg" alt="" /></a></li>
                            <li><a href="https://twitter.com/PeckDating"><img src="images/twitter_icon.svg" alt="" /></a></li>
                        </ul>
                    </div>
                    <div className="center_cnt">
                        <span>Product of</span>
                        <span className="footer_logo"><img src="images/fliptree_logo.png" alt="" /></span>
                        <span className="logo_text"><img src="images/fliptree_logo_text.png" alt="" /></span>
                    </div>
                    <div className="right">
                        <ul className="social_listing mt">
                            <li>
                                <a href="https://play.google.com/store/apps/details?id=com.fliptree.peck" className="icon">
                                    <figure><img src="images/playstore.svg" alt="" /></figure>
                                </a>
                            </li>
                            <li>
                                <a href="https://apps.apple.com/us/app/peck-pride-meet-greet-match/id6469529163" className="icon">
                                    <figure><img src="images/appstore.svg" alt="" /></figure>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="bottom text-center">
                    <div className="container">
                        <span className="copyright d-block small">Copyright © 2023. All Rights Reserved.<br />
                            <Link to="privacy" element={<Privacy/>}>Privacy</Link> & <Link to="terms" element={<Terms/>}>Terms</Link></span>
                    </div>
                </div>
            </footer>
            {/* <!-- === --> */}
        </>
    )
}

export default Footer